import { Link } from "react-router-dom"
import Menu from "../Menu"
import { useEffect, useRef, useState } from "react"

export default function Header1({ scroll, isMobileMenu, handleMobileMenu, isOffCanvas, handleOffCanvas, isSearch, handleSearch }) {
  const [hideOnScroll, setHideOnScroll] = useState(false);
  const lastScrollY = useRef(window.scrollY);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setHideOnScroll(true);
      } else {
        setHideOnScroll(false);
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
	return (
		<>

			<header className="header-section-22">
				<div className="header-top-sectionss top-style-2 fix">
					<div className="container-fluid">
						<div className="header-top-wrappers style-2">
							<ul className="contact-list">
								<li>
									<i className="far fa-envelope" />
									<a href="mailto:info@vmakewpc.com">info@vmakewpc.com</a>
								</li>
								<li>
									<i className="fa-solid fa-phone-volume" />
									<a href="tel:+917022565599">+91 7022565599</a>{" "}
								</li>
							</ul>
							<div className="top-right">
								<div className="social-icon d-flex align-items-center">
									<span>Follow Us:</span>
									<Link to="/#">
										<i className="fab fa-facebook-f" />
									</Link>
									<Link to="/#">
										<i className="fab fa-twitter" />
									</Link>
									<Link to="/#">
										<i className="fa-brands fa-linkedin-in" />
									</Link>
									<Link to="/#">
										<i className="fa-brands fa-youtube" />
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="header-sticky" className={`header-1 ${scroll ? "sticky" : ""} ${hideOnScroll ? "hide-navbar" : ""}`}>
					<div className="main-logo">
						<Link to="/">
							<img src="assets/img/logo/Vmake_logo.svg" alt="logo-image" width="150" height="80" />
						</Link>
					</div>
					<div className="container-fluid">
						<div className="mega-menu-wrapper">
							<div className="header-main">
								<div className="logo d-none">
									<Link to="/" className="header-logo">
										<img src="assets/img/logo/Vmake_logo.svg" alt="logo-img" width="150" height="80" />
									</Link>
								</div>
								<div className="header-left">
									<div className="mean__menu-wrapper">
										<div
											className="main-menu"
										>
											<Menu />
										</div>
									</div>
								</div>
								<div className="header-right d-flex justify-content-end align-items-center">
									{/* <a className="search-trigger search-icon" onClick={handleSearch}>
										<i className="fal fa-search" />
									</a> */}
									{/* <div className="header-button">
										<Link to="/contact" className="theme-btn">
											Contact us
											<i className="fa-solid fa-arrow-right-long" />
										</Link>
									</div> */}
									<div className="header__hamburger d-xl-none my-auto">
										<div
											className="sidebar__toggle"
											type="button"
											onClick={handleOffCanvas}
										>
											<i className="fas fa-bars" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	)
}
